import { useApi } from 'hooks'
import { useMutation } from '@tanstack/react-query'
import { GAHandler } from 'utils/GA'

const useLogin = () => {

  const { apiFetch } = useApi()

  const url = `/auth/loginExternal`;

  const loginExternal = ({ provider, token }) => {
    return apiFetch({
      url: `${url}/${provider}`,
      method: 'POST',
      data: {
        code: token,
      }
    })
    .then( res => {
      GAHandler(`login_${provider}`);
      return res.data
    })
    .catch(err => {
      GAHandler(`login_${provider}_error`);
      throw err
    })

  }

  const {
    mutate,
    ...rest 
  } = useMutation(loginExternal)

  return {
    loginExternal: mutate,
    ...rest
  }

}

export default useLogin
